'use client';
import React from 'react';
import Image from 'next/image';
import RatingStars from '@/components/ui/RatingStars';
import { Heart } from "lucide-react";
import StockBadge from '@/components/common/StockBadge';
import { ImageDTO } from '@/types/product';

interface ProductGalleryMobileProps {
  productId: number;
  mainImage: ImageDTO;
  rating: number;
  reviewCount: number;
  onFavoriteToggle?: () => void;
  isFavorite?: boolean;
  className?: string;
}

const ProductGalleryMobile: React.FC<ProductGalleryMobileProps> = ({
  productId,
  mainImage,
  rating,
  reviewCount,
  onFavoriteToggle,
  isFavorite = false,
  className = ''
}) => {
  return (
    <div data-component-id="src/components/sections/mobile/ProductGalleryMobile.tsx:29:4" data-component-path="src/components/sections/mobile/ProductGalleryMobile.tsx" data-component-line="29" data-component-file="ProductGalleryMobile.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex flex-col gap-3 p-4 ${className}`}>
      {/* Imagen principal */}
      <div data-component-id="src/components/sections/mobile/ProductGalleryMobile.tsx:31:6" data-component-path="src/components/sections/mobile/ProductGalleryMobile.tsx" data-component-line="31" data-component-file="ProductGalleryMobile.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20rounded-%5B12px%5D%20w-full%20h-%5B300px%5D%20p-4%20shadow-sm%22%7D" className="relative rounded-[12px] w-full h-[300px] p-4 shadow-sm" style={{ backgroundColor: 'rgba(235, 147, 112, 0.45)' }}>
        <StockBadge data-component-id="src/components/sections/mobile/ProductGalleryMobile.tsx:32:8" data-component-path="src/components/sections/mobile/ProductGalleryMobile.tsx" data-component-line="32" data-component-file="ProductGalleryMobile.tsx" data-component-name="StockBadge" data-component-content="%7B%22elementName%22%3A%22StockBadge%22%7D" productId={productId} />
        {/* Rating y favoritos */}
        <div data-component-id="src/components/sections/mobile/ProductGalleryMobile.tsx:34:8" data-component-path="src/components/sections/mobile/ProductGalleryMobile.tsx" data-component-line="34" data-component-file="ProductGalleryMobile.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-row%20items-center%20-ml-6%22%7D" className="flex flex-row items-center -ml-6">
          {/* TODO: Comentado temporalmente - Rating con estrellas
          <div className="flex flex-row items-center gap-0">
            <RatingStars rating={rating} readonly className="scale-75" />
            <span className="text-global-1 font-tt-norms font-medium text-sm leading-4 -ml-4">
              ({reviewCount})
            </span>
          </div>
          */}
          
          {/* Botón de favoritos */}
          {/* TODO: Añadir el icono de favorito
          <button 
            onClick={onFavoriteToggle}
            className="cursor-pointer transition-transform hover:scale-110 ml-auto"
          >
            
            <Heart 
              className={`w-5 h-5 ${isFavorite ? 'text-red-500 fill-red-500' : 'text-[#3d1c1a]'}`} 
            />
            
          </button>
          */}
        </div>
        
        {/* Imagen del producto */}
        <div data-component-id="src/components/sections/mobile/ProductGalleryMobile.tsx:60:8" data-component-path="src/components/sections/mobile/ProductGalleryMobile.tsx" data-component-line="60" data-component-file="ProductGalleryMobile.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20h-%5B220px%5D%22%7D" className="flex justify-center items-center h-[220px]">
          <Image data-component-id="src/components/sections/mobile/ProductGalleryMobile.tsx:61:10" data-component-path="src/components/sections/mobile/ProductGalleryMobile.tsx" data-component-line="61" data-component-file="ProductGalleryMobile.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-full%20h-full%20max-w-%5B280px%5D%20max-h-%5B280px%5D%22%7D" 
            src={mainImage.src}
            alt={mainImage.alt}
            width={280}
            height={280}
            className="object-contain w-full h-full max-w-[280px] max-h-[280px]"
          />
        </div>
      </div>
    </div>
  );
};

export default ProductGalleryMobile; 